export const average = (array) => {
    let total = 0;
    for (let i = 0; i < array.length; i++) {
        total += array[i];
    }
    return total / array.length;
}

export const roundToStep = (value, step, min, max) => {
    const transform = min % step;
    let roundedValue = Math.round(value / step) * step - transform;

    if (roundedValue < min) {
        roundedValue = min;
    } else if (roundedValue > max) {
        roundedValue = Math.floor(max / step) * step - transform;
    }

    return roundedValue;
};

// Calculates a value based on a display multiplier and optional rounding.
// The value is first multiplied by the given display multiplier.
// If rounding is not prevented, it is adjusted to the nearest step considering the minimum value.
export const calculateValue = (value, displayMultiplier, preventRound, step, min, max) => {
    let calculatedValue = value * displayMultiplier;
    return preventRound ? calculatedValue : roundToStep(calculatedValue, step, min, max);
};

export const calculateRangeValue = (value, displayMultiplier, preventRound, step, min, max) => {
    let [firstValue, secondValue] = [
        value[0] * displayMultiplier,
        value[1] * displayMultiplier
    ];

    if (!preventRound) {
        firstValue = roundToStep(firstValue, step, min, max);
        secondValue = roundToStep(secondValue, step, min, max);
    }

    return [firstValue, secondValue];
};
